/**
 * titre.js
 */

// Import
import "./titre.scss";
import $ from 'jquery';

$(document).ready(function() {
    console.log('override: components/titre');
});

